<script lang="ts" setup>
import { ref, watch, onMounted } from 'vue';

import type { Nullable } from '@immersive-tech/viewer-engine';

interface IProps {
  label: string;
  modelValue: boolean;
  boldLabel?: boolean;
}

interface IEmits {
  (e: 'update:modelValue', value: boolean): unknown;
}

const emit = defineEmits<IEmits>();
const props = defineProps<IProps>();
const input = ref<Nullable<HTMLInputElement>>(null);
const currentToggleValue = ref(props.modelValue);

const currentToggleValueWatcher = (newValue: boolean) => {
  emit('update:modelValue', newValue);
};

const propsModelValueWatcher = (newValue: boolean) => {
  currentToggleValue.value = newValue;
};

const onMountedHandler = () => {
  if (input.value) {
    input.value.checked = currentToggleValue.value;
  }
};

watch(currentToggleValue, currentToggleValueWatcher);
watch(() => props.modelValue, propsModelValueWatcher);
onMounted(onMountedHandler);
</script>

<template>
  <div v-if="modelValue !== undefined" class="flex flex-row justify-between items-center">
    <p class="text-xs cursor-pointer mr-1 flex-grow" :class="{ 'font-bold': boldLabel === true }" @click="currentToggleValue = !currentToggleValue">
      {{ label }}
    </p>
    <label class="relative inline-block" :class="`h-[18px] w-[40px]`">
      <input ref="input" v-model="currentToggleValue" type="checkbox" class="opacity-0 w-0 h-0 peer">
      <span
        class="
          absolute
          cursor-pointer
          top-0
          left-0
          right-0
          bottom-0
          bg-gray-300
          transition-colors
          duration-300
          rounded
          before:absolute
          before:left-[4px]
          before:bottom-[4px]
          before:bg-white
          before:rounded
          peer-checked:bg-blue-400
          peer-focus:shadow
        "
        :class="`
          before:h-[10px]
          before:w-[10px]
          peer-checked:before:translate-x-[22px]
        `"
      />
    </label>
  </div>
</template>
